import { render, staticRenderFns } from "./DownArrow.vue?vue&type=template&id=2b65bb8f&scoped=true"
var script = {}
import style0 from "./DownArrow.vue?vue&type=style&index=0&id=2b65bb8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b65bb8f",
  null
  
)

export default component.exports